module.exports = __webpack_public_path__ + "static/img/ccon-doi-kaka.6818d307.svg";